import { Injectable, inject, signal } from '@angular/core'
import { CreatePendencyGQL, UpdatePendencyAssigneeGQL, UpdatePendencyAssigneeInput, UpdatePendencyGQL } from '@generated/sammathnaur.graphql'
import { firstValueFrom } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class PendenciesService {

  public isLoading = signal<boolean>(false)
  public readonly pendencies = signal<any[]>([])

  private readonly createPendencyGQL = inject(CreatePendencyGQL)
  private readonly updatePendencyGQL = inject(UpdatePendencyGQL)
  private readonly updatePendencyAssignee = inject(UpdatePendencyAssigneeGQL)

  public async save(input: any): Promise<any> {
    if ('id' in input && input?.id) {
      return firstValueFrom(this.updatePendencyGQL.mutate({ variables: { input } }))
    } else {
      return firstValueFrom(this.createPendencyGQL.mutate({ variables: { input } }))
    }
  }

  public async updateAssignee(input: UpdatePendencyAssigneeInput): Promise<any> {
    return firstValueFrom(this.updatePendencyAssignee.mutate({ variables: { input } }))
  }
}
